import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['file-preview'],
  queryOptions: {},
};

const previewFile = async (dpsID, fileId, dcID = null,) => {
  const url = dcID ? `/api/dps/${dpsID}/suppliers/${dcID}/files/${fileId}` : `/api/dps/${dpsID}/files/${fileId}`;
  const {
    data: { data },
  } = await axios.get(url);

  return data;
};

export const useFilePreview = (dpsID, fileId, dcID = null, queryParams = {}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, fileId], () => previewFile(dpsID, fileId, dcID), {
    initialData: { url: '', name: '', file_ext: '', mime_type: '' },
    enabled: !!fileId,
    select: ({ url, name, file_ext: FileExt, mime_type: MimeType }) => ({ url, name, FileExt, MimeType }),
    ...queryOptions,
  });
};
